import { HomeApp } from "./app";
export default HomeApp;
